export default __webpack_public_path__ + "static/silvia-9603ca5aef6aac287f8e16d58a655d5e.png";